import React from 'react';
import Icon from '../../../components/AppIcon';

const SettlementMetricsCard = ({ title, value, subtitle, trend, trendValue, icon, iconBg, iconColor }) => {
  const isPositiveTrend = trend === 'up';
  const trendColor = isPositiveTrend ? 'text-success' : 'text-error';
  const trendBg = isPositiveTrend ? 'bg-success/10' : 'bg-error/10';

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6 shadow-elevation-1 hover:shadow-elevation-2 transition-smooth">
      <div className="flex items-start justify-between mb-4">
        <div className={`w-12 h-12 md:w-14 md:h-14 rounded-lg ${iconBg} flex items-center justify-center`}>
          <Icon name={icon} size={24} color={iconColor} />
        </div>
        {trend && (
          <div className={`flex items-center gap-1 px-2 py-1 rounded-lg ${trendBg}`}>
            <Icon name={isPositiveTrend ? 'TrendingUp' : 'TrendingDown'} size={14} className={trendColor} />
            <span className={`text-xs font-semibold ${trendColor}`}>{trendValue}</span>
          </div>
        )}
      </div>
      <div>
        <h3 className="text-sm md:text-base text-muted-foreground mb-2">{title}</h3>
        <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-1 data-text">{value}</p>
        {subtitle && <p className="text-xs md:text-sm text-muted-foreground">{subtitle}</p>}
      </div>
    </div>
  );
};

export default SettlementMetricsCard;